import React from 'react';

import PropTypes from 'prop-types';

import { submitSAMLRequest } from 'components/saml/helpers';

export default function SamlInviteLandingPage({
  accountName,
  createPasswordLink,
  logoSrc,
  samlProviderConfigurationUuid,
}) {
  return (
    <div className='form-container tw-border-white tw-bg-white'>
      {logoSrc && (
        <div className='invite-logo-container m-b-20'>
          <img alt='Logo' src={logoSrc} />
        </div>
      )}
      <p className='text-center text-center m-0 tw-text-l tw-font-normal tw-tracking-auto'>
        <span>To get started, log in to your</span>
        <span className='tw-font-semibold'> {accountName} </span>
        <span>account.</span>
      </p>
      {samlProviderConfigurationUuid && (
        <a
          className='tw-apply-filled-button tw-apply-filled-button--lg tw-apply-filled-button--h-auto tw-apply-filled-button--mint tw-apply-filled-button--on-light m-t-20 tw-w-full tw-justify-center'
          onClick={() => submitSAMLRequest({ samlProviderConfigurationUuid })}
        >
          <span className='tw-mb-[13px] tw-mt-[13px] tw-text-center'>
            Log in with single{' '}
            <span className='tw-whitespace-nowrap'>sign-on</span> (SSO)
          </span>
        </a>
      )}
      {createPasswordLink && (
        <div className='secondary-links secondary-links--centered tw-m-0 tw-mt-5 tw-text-grey-900'>
          <span className='m-r-8'>Or</span>
          <a
            className="tw-font-semibold tw-text-grey-900 before:tw-bg-mint-200 before:tw-content-[''] hover:tw-text-mint-200"
            href={createPasswordLink}
          >
            create password and log in
          </a>
        </div>
      )}
    </div>
  );
}

SamlInviteLandingPage.propTypes = {
  logoSrc: PropTypes.string,
  accountName: PropTypes.string.isRequired,
  samlProviderConfigurationUuid: PropTypes.string,
  createPasswordLink: PropTypes.string,
};
